

import {
  AfterContentInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { Subscription } from 'rxjs';

import { BooleanInput } from 'mwc/core/types';
import { InputBoolean } from 'mwc/core/util';

import { MwcResizeObserver } from './resize-observer.service';

@Directive({
  selector: '[mwcResizeObserver]'
})
export class MwcResizeObserverDirective implements AfterContentInit, OnDestroy, OnChanges {
  static ngAcceptInputType_mwcResizeObserverDisabled: BooleanInput;
  @Output() readonly mwcResizeObserve = new EventEmitter<ResizeObserverEntry[]>();
  @Input() @InputBoolean() mwcResizeObserverDisabled = false;
  private currentSubscription: Subscription | null = null;

  private subscribe(): void {
    this.unsubscribe();
    this.currentSubscription = this.mwcResizeObserver.observe(this.elementRef).subscribe(this.mwcResizeObserve);
  }

  private unsubscribe(): void {
    this.currentSubscription?.unsubscribe();
  }

  constructor(private mwcResizeObserver: MwcResizeObserver, private elementRef: ElementRef<HTMLElement>) {}

  ngAfterContentInit(): void {
    if (!this.currentSubscription && !this.mwcResizeObserverDisabled) {
      this.subscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { mwcResizeObserve } = changes;
    if (mwcResizeObserve) {
      if (this.mwcResizeObserverDisabled) {
        this.unsubscribe();
      } else {
        this.subscribe();
      }
    }
  }
}
